import React, {useEffect, useRef, useState} from 'react';
import {BarGraph} from "./BarGraph";
import {subtle_palette} from "../color/Palettes";

function defaultData(n, max) {
    const data = []
    const keys = []
    for (let i = 0; i < n; i++) {
        data.push(
            {
                group: `Tema ${i+1}`,
                data: {
                    group: `Tema ${i+1}`,
                    value: i * (max / n)
                }
            }
        )
        keys.push(`Tema ${i+1}`)
    }


    return {
        groups: data,
        keys: keys,
        colors: "grays",
        horizontal: true,
        stacked: false
    };
}

export function ScrollActivatedBargraph({data, keys, min, max}) {


    const [hasActivated, setHasActivated] = useState(true)
    const [activateGraph, setActive] = useState(true)
    const targetRef = useRef(null);

    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => {
                setActive(entry.isIntersecting);
                if(entry.isIntersecting) {
                    setHasActivated(true)
                }
            },
            { threshold: 0.7 } // Trigger when 50% of the element is visible
        );

        if (targetRef.current) {
            observer.observe(targetRef.current);
        }

        return () => observer.disconnect();
    }, [])


    const colors = ["#16d592", "#52d378", "#75d05d", "#93cb43", "#afc528", "#cbbd07", "#e5b300", "#ffa600"];

    if (data == null || data.groups.length === 0) {
        const defData = defaultData(5, 100 );
        return (
            <div className={""} style={{minHeight: "15vh", height: ((5 + 12 / defData.groups.length)*defData.groups.length)+"vh"}} ref={targetRef}>
                <BarGraph
                    data={hasActivated || activateGraph ? defData : {groups: [], keys: [], stacked: false, horizontal: true}}
                    height={"100%"}
                    keys={defData.keys}
                    xIndex={"group"}
                    horizontal={true}
                    borderRadius={10}
                    innerPadding={5}
                    labelFun={(item) => `${Math.round(item.value)}%`}
                    colorBy={"indexValue"}
                    margin={{top: 50, right: 50, bottom: 80, left: 120}}
                    minValue={data.minValue ?? 0}
                    maxValue={data.maxValue ?? 100}
                    format={{
                        horizontal:true,
                        stacked:true,
                        colors:"greys"
                    }}
                    xAxisRotation={90}
                />
            </div>
        );
    }

    return (
        <div className={""} style={{minHeight: "15vh", height: ((5 + 12 / data.groups.length)*data.groups.length)+"vh"}} ref={targetRef}>
            <BarGraph
                data={hasActivated ? data : (activateGraph ? data : {groups: [], keys: [], stacked: false, horizontal: true})}
                height={"100%"}
                keys={keys}
                xIndex={"group"}
                horizontal={true}
                borderRadius={10}
                innerPadding={5}
                labelFun={(item) => `${Math.round(item.value)}%`}
                colorBy={"indexValue"}
                colorList={colors.reverse()}
                margin={{top: 50, right: 50, bottom: 80, left: 120}}
                minValue={data.minValue ?? 0}
                maxValue={data.maxValue ?? 100}
                format={{
                    horizontal:true,
                    stacked:false,
                    colors: data.colors
                }}
                xAxisRotation={90}
            />
        </div>
    );

}